function initJstUtilityBar(root = document) {
  root.querySelectorAll('[data-jst-utility]').forEach((bar) => {
    if (bar.dataset.initialized === 'true') return;
    bar.dataset.initialized = 'true';

    const announcement = bar.querySelector('[data-jst-announcement]');
    const closeButton = bar.querySelector('[data-jst-announcement-close]');
    const storageKey = `jst-announcement-${bar.dataset.sectionId || 'default'}`;

    try {
      if (window.sessionStorage.getItem(storageKey) === 'dismissed' && announcement) {
        announcement.hidden = true;
      }
    } catch (error) {
      // The announcement still works if storage is unavailable.
    }

    closeButton?.addEventListener('click', () => {
      if (announcement) announcement.hidden = true;
      try {
        window.sessionStorage.setItem(storageKey, 'dismissed');
      } catch (error) {
        // Dismissal remains active for the current page.
      }
    });
  });
}

initJstUtilityBar();
document.addEventListener('shopify:section:load', (event) => initJstUtilityBar(event.target));
